import React, { useCallback, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { FlashList } from '@shopify/flash-list';
import Indicator from 'design-system/Indicator';
import { AppView, SCREEN_BOTTOM_PADDING, SCROLL_INDICATOR_INSETS, } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { formatDateForSectionHeaderWithDate } from 'utils/formatting';
import { addLastInSectionInfo } from 'utils/getTransactions';
import { selectGroupAnalytics, selectGroupTransactions, } from 'reducers/selectors';
import GroupTransactionRow from './components/GroupTransactionRow';
import { getUserIds } from './utils/getUserIds';
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const keyExtractor = ((item) => String(item.id));
const getFlashListData = (txns) => {
    if (!txns?.length) {
        return [];
    }
    const flashListData = [];
    let activeDate;
    txns.forEach((txn) => {
        let didAddNewSection = false;
        const dateToUseRaw = txn.date;
        const dateToUse = formatDateForSectionHeaderWithDate(dateToUseRaw);
        if (!activeDate || dateToUse !== activeDate) {
            activeDate = dateToUse;
            addLastInSectionInfo(flashListData);
            flashListData.push({
                type: 'SECTION_HEADER',
                id: dateToUse,
                sectionTitle: dateToUse,
            });
            didAddNewSection = true;
        }
        if (!didAddNewSection) {
            flashListData.push(txn);
        }
        else {
            flashListData.push({ ...txn, isFirstInSection: true });
        }
    });
    addLastInSectionInfo(flashListData);
    return flashListData;
};
// todo: need to add infinite scroll pagination
const GroupTransactionsScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const { groupId } = route.params;
    const transactions = useAppSelector((store) => selectGroupTransactions(store, groupId));
    const analytics = useAppSelector((store) => selectGroupAnalytics(store, groupId));
    const usersByIds = useMemo(() => getUserIds(analytics?.users || []), [analytics]);
    const transactionsFiltered = useMemo(() => getFlashListData(transactions), [transactions]);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const handleTransactionPress = useCallback((transaction) => {
        navigation.navigateDeprecated('GroupTransaction', {
            transactionId: transaction.id,
            groupId,
        });
    }, [groupId]);
    const renderItem = useCallback(({ item }) => (<GroupTransactionRow item={item} usersByIds={usersByIds} handleTransactionPress={handleTransactionPress}/>), [handleTransactionPress, usersByIds]);
    if (!transactions) {
        return (<AppView>
            <Indicator dark includeHeaderHeight/>
          </AppView>);
    }
    return (<AppView withFrame={false}>
          <AnimatedFlashList renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} data={transactionsFiltered} keyExtractor={keyExtractor} contentContainerStyle={contentContainerStyle} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>
        </AppView>);
}, ({ colors }) => ({
    title: 'Transactions',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default GroupTransactionsScreen;
